import React from 'react';

const InfoAlert = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Ikon Okej"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 26.6C20.9588 26.6 26.6 20.9588 26.6 14C26.6 7.04121 20.9588 1.4 14 1.4C7.04121 1.4 1.4 7.04121 1.4 14C1.4 20.9588 7.04121 26.6 14 26.6ZM14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
        fill="#353636"
      />
      <path
        d="M14.6036 7.98621C14.3324 8.26207 14.0036 8.4 13.6174 8.4C13.2312 8.4 12.9002 8.26207 12.6243 7.98621C12.3485 7.71034 12.2105 7.37931 12.2105 6.9931C12.2105 6.6069 12.3462 6.27816 12.6174 6.0069C12.8887 5.73563 13.222 5.6 13.6174 5.6C14.0036 5.6 14.3324 5.73563 14.6036 6.0069C14.8749 6.27816 15.0105 6.6069 15.0105 6.9931C15.0105 7.37931 14.8749 7.71034 14.6036 7.98621Z"
        fill="#353636"
      />
      <path
        d="M17.5 20.3739C17.5 20.7197 17.2197 20.9999 16.8739 20.9998L11.1224 20.9975C10.7786 20.9974 10.5 20.7187 10.5 20.3749C10.5 20.0389 10.7665 19.7636 11.102 19.7459C11.5906 19.7202 12.2179 19.6757 12.3404 19.6123C12.5465 19.5057 12.71 19.3294 12.8309 19.0833C12.9519 18.8373 13.0124 17.8471 13.0124 17.15V14.1084C13.0124 13.4821 12.9806 12.9177 12.9496 12.5162C12.9224 12.1636 12.6257 11.9 12.272 11.9H11.2C10.8134 11.9 10.5 11.5866 10.5 11.2C10.5 10.8134 10.8134 10.5 11.2 10.5H14.4949C14.8793 10.5 15.1917 10.81 15.1948 11.1943L15.2432 17.15C15.2432 17.8553 15.2992 18.8435 15.4111 19.0772C15.5231 19.3109 15.6889 19.4852 15.9084 19.6C16.0297 19.6635 16.503 19.7102 16.9022 19.7393C17.2363 19.7637 17.5 20.039 17.5 20.3739Z"
        fill="#353636"
      />
      <defs></defs>
    </svg>
  );
};
export default InfoAlert;
